// extracted by mini-css-extract-plugin
export default {"tab":"NavLinks_tab__uW9Hk","active":"NavLinks_active__qvd3X"};